import { useState, useEffect } from "react"
import moment from "moment"

import { getTrafficDetails } from "services/state/actions"

moment.locale("pt-br")

export const useTrafficDetails = (serviceId) => (dispatch) => {
  const [dates, setDates] = useState({
    startDate: moment().subtract(10, "d"),
    endDate: moment()
  })
  const [submit, setSubmit] = useState(true)

  const { startDate, endDate } = dates

  useEffect(() => {
    if (!submit) return

    getTrafficDetails({
      startDate: moment(startDate).format("DD/MM/YYYY"),
      endDate: moment(endDate).format("DD/MM/YYYY"),
      serviceId
    })(dispatch)

    setSubmit(false)
  }, [submit])

  const changeRangeDatesForDetailing = ({ startDate, endDate }) => {
    setDates({
      startDate,
      endDate
    })
  }

  const submitTrafficDetails = () => {
    if (!startDate || !endDate) {
      throw new Error("Must have a start and end date")
    }

    setSubmit(true)
  }

  return [dates, changeRangeDatesForDetailing, submitTrafficDetails]
}



// WEBPACK FOOTER //
// ./src/scenes/DataTraffic/utils/useTrafficDetails.js